import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { swalError, swalSuccess } from "@/utils/lib/swal";
import { SubmitButton } from "@/components/ui/button";
import {
  SubdistrictPayloadSchema,
  subdistrictPayloadSchema,
  useSubdistrictCreate,
} from "@/api/subdistrict";
import { SubdistrictFormFields } from "./SubdistrictFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";
import { ErrorMessageFromResponse } from "@/api/types";

export function SubdistrictCreateForm() {
  const form = useForm<SubdistrictPayloadSchema>({
    resolver: zodResolver(subdistrictPayloadSchema),
  });
  const { mutate, isPending } = useSubdistrictCreate();
  const navigate = useNavigate();

  function handleSubmit(values: SubdistrictPayloadSchema) {
    mutate(
      { data: values },
      {
        onSuccess: () => {
          swalSuccess
            .fire({
              text: "District has been created",
            })
            .then(() => navigate("/master-data/district"));
        },
        onError: (error) => {
          swalError.fire({
            text:
              (error as ErrorMessageFromResponse).response?.data.data ??
              error.message,
          });
        },
      },
    );
  }

  return (
    <FormContainer form={form} onSubmit={handleSubmit}>
      <SubdistrictFormFields />
      <div className="ml-auto flex gap-x-2">
        <Anchor href="/master-data/district" mood="axiata-blue-outline">
          Cancel
        </Anchor>
        <SubmitButton loading={isPending} />
      </div>
    </FormContainer>
  );
}
